// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"759130aa","376":"04d4d6fe","622":"352a9576","896":"ffafdcdd"}[chunkId] + ".chunk.css";
};